import React from "react";
import { motion } from "framer-motion";

import { styles } from "../styles";
import { ComputersCanvas } from "./canvas";

const Hero = () => {
	return (
		<section className="w-full max-auto">
			<div
				className={`${styles.paddingX} inset-0 max-w-[7xl] mx-auto flex flex-row items-start gap-5`}>
				<div className="flex flex-col justify-center items-center mt-5">
					<div className="w-5 h-5 rounded-full bg-[#915eff]" />
					<div className="w-1 h-40 violet-gradient" />
				</div>
				<div>
					<h1 className={`${styles.heroHeadText} text-white`}>
						Hi, I'm
						<span className="text-[#915eff]"> Gunapathi</span>
						<p
							className={`${styles.heroSubText} mt-2 text-white-100`}>
							I develope 3D visuals, user{" "}
							<br className="sm:block hidden" /> interfaces and
							Web app
						</p>
					</h1>
				</div>
			</div>

			{/* CANVAS */}
			<div className="relative h-[200px] md:h-[500px] md:max-w-[800px] mx-auto">
				<ComputersCanvas />
			</div>

			{/* MOUSE MODEL ANIMATION */}
			<div className="w-full flex justify-center items-center">
				<a href="#about">
					<div className="w-[35px] h-[54px] rounded-3xl border-4 border-secondary flex justify-center items-center">
						<motion.div
							animate={{ y: [-10, 15, -10] }}
							transition={{
								duration: 1.5,
								repeat: Infinity,
								repeatType: "loop",
							}}
							className="w-3 h-3 rounded-full bg-secondary mb-1"></motion.div>
					</div>
				</a>
			</div>
		</section>
	);
};

export default Hero;
